import { Injectable, inject } from '@angular/core';

import { Actions } from '@ngrx/effects';
import { map } from 'rxjs/operators';

import { createEffectFactory } from '@core/ngrx-legacy';

import { RemoteTemplateHttpClient } from './remote-template-http.client';
import { RemoteTemplateActions } from './remote-template.store';

@Injectable({ providedIn: 'root' })
export class RemoteTemplateEffects {
  private readonly remoteTemplateHttpClient = inject(RemoteTemplateHttpClient);
  private readonly actions$ = inject(Actions);

  public effect = createEffectFactory(RemoteTemplateActions, this.actions$);

  public fetchRemoteTemplates$ = this.effect(RemoteTemplateActions.fetchCollection, ({ payload }) =>
    this.remoteTemplateHttpClient
      .fetch(payload!.scope)
      .pipe(map(remoteTemplates => ({ data: remoteTemplates, scope: payload!.scope }))),
  );
}
